import { BiError } from 'react-icons/bi';
import error404 from 'static/images/404.gif';
import * as S from './styles';

export function NotFoundPage() {
  return (
    <S.Wrapper>
      <BiError />

      <S.Image src={error404} alt="Página não encontrada" />
    </S.Wrapper>
  );
}
